import "./_main-navigation-modules.scss"
import React from "react"
import ReactDOM from "react-dom"
import MainNavigation from "./main-navigation"

export default class MainNavigationModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.elem.navigationContainer = document.querySelector("[data-navigation-elements]")
    self.elem.onlyTopLevel = elem.dataset.onlyTopLevel ? true : false
    self.elem.modifier = elem.dataset.modifier
    self.elem.pageType = elem.dataset.pageType

    self.init()
    return self
  }

  init() {
    const self = this
    if (self.elem.pageType === "CheckoutPage" || self.elem.pageType === "OrderStatusPage") return
    const navigationElements =
      self.elem.navigationContainer &&
      self.elem.navigationContainer.dataset.navigationElements &&
      JSON.parse(self.elem.navigationContainer.dataset.navigationElements)
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<MainNavigation modifier={self.elem.modifier} data={navigationElements} onlyTopLevel={self.elem.onlyTopLevel} />, self.elem)
  }
}
